// extracted by mini-css-extract-plugin
module.exports = {"root":"CosmeticCreateEdit_root__vL1Ke"};